import gButton from "@/components/g-button/g-button.vue";
import gCard from "@/components/g-card/g-card.vue";
import gPdf from "@/components/g-pdf/g-pdf.vue";

const name = 'NotaFiscalPedidoEmAndamento'

export default {
  name,

  components:{ 
    "g-button": gButton,
    "g-card": gCard,
    "g-pdf": gPdf,
  },

  props: { },

  mounted() { },

  updated() { },

  data() {
    return { }
  },

  methods: { 
    voltar() {
      this.$router.push(`/pedido-em-andamento`);
    }
  },

  computed: { }
};